
import { defineComponent } from "@vue/runtime-core";
import ImageCard from "./ImageCard.vue";

export default defineComponent({
    components: { ImageCard },
    name: "Navigation",
    data() {
        return {
            imageCards: [
                // get gifs of the algos working and use them as image sources
                {
                    name: "Sorting",
                    imageSrc: "/images/sorting.gif",
                    routePath: "/sorting-algos",
                    description: "Visualization of some sorting Algorithms",
                },
                {
                    name: "Path Finders and Maze Generators",
                    imageSrc: "/images/pathfinding.gif",
                    routePath: "/path-finding-algos",
                    description:
                        "Visualization of Path Finding and Maze Generating Algorithms",
                },
                {
                    name: "Data Structures' Algorithms",
                    imageSrc: "/images/DsSS.png",
                    routePath: "/common-ds-algo",
                    description:
                        "Visualization of Algorithms related to Data Structures",
                },
            ],
        };
    },
});
